import React, { useMemo, useState } from 'react';
import {
  Box,
  Button,
  Grid,
  Icon,
  ListItemIcon,
  Menu,
  MenuItem,
} from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';
import FilterBar from './FilterBar';
import styles from './styles';

const getVisibleActions = (actions = []) =>
  actions?.filter(({ show = true }) =>
    typeof show === 'function' ? show() : show
  );

const sortActionsByName = (actions = []) =>
  [...actions].sort((a, b) =>
    (a?.name || '').localeCompare(b?.name || '', 'pt-BR', {
      sensitivity: 'base',
    })
  );

const Toolbar = ({
  actions = [],
  filterFields = [],
  filterForm,
  grid,
  loading,
  onFilter,
  selection = [],
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const visibleActions = useMemo(() => getVisibleActions(actions), [actions]);
  const primaryActions = sortActionsByName(
    visibleActions?.filter(({ placement }) => placement === 'primary')
  );
  const overflowActions = sortActionsByName(
    visibleActions?.filter(({ placement = 'menu' }) => placement === 'menu')
  );
  const optionsLabel = primaryActions?.length ? 'Mais Opções' : 'Opções';

  const handleAction = (action) => {
    setAnchorEl(null);

    if (action) {
      action(selection);
    }
  };

  if (!visibleActions?.length && !filterFields?.length) {
    return null;
  }

  return (
    <Grid container spacing={1.5} alignItems="center" sx={styles.toolbar}>
      <Grid item xs={12} lg={4} xl={5}>
        <Box sx={styles.toolbarActions}>
          {primaryActions?.map(({ action, icon, name }) => (
            <Button
              key={name}
              size="small"
              variant="contained"
              startIcon={icon ? <Icon>{icon}</Icon> : null}
              onClick={() => handleAction(action)}
            >
              {name}
            </Button>
          ))}
          {!!overflowActions?.length && (
            <>
              <Button
                size="small"
                variant="outlined"
                startIcon={<MoreHoriz />}
                aria-haspopup="true"
                aria-controls={anchorEl ? 'dataview-toolbar-menu' : undefined}
                aria-expanded={anchorEl ? 'true' : undefined}
                onClick={({ currentTarget }) => setAnchorEl(currentTarget)}
              >
                {optionsLabel}
              </Button>
              <Menu
                id="dataview-toolbar-menu"
                anchorEl={anchorEl}
                open={!!anchorEl}
                onClose={() => setAnchorEl(null)}
              >
                {overflowActions?.map(({ action, icon, name }) => (
                  <MenuItem key={name} onClick={() => handleAction(action)}>
                    {icon && (
                      <ListItemIcon>
                        <Icon>{icon}</Icon>
                      </ListItemIcon>
                    )}
                    {name}
                  </MenuItem>
                ))}
              </Menu>
            </>
          )}
        </Box>
      </Grid>
      <Grid item xs={12} lg={8} xl={7}>
        <FilterBar
          fields={filterFields}
          form={filterForm}
          grid={grid}
          loading={loading}
          onSubmit={onFilter}
        />
      </Grid>
    </Grid>
  );
};

export default Toolbar;
